// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDAvatar from "components/MDAvatar";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Ajce Hostel App React example components
import TimelineItem from "examples/Timeline/TimelineItem";
import { getInOutHistory } from "framework/students/summary";
import { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";

import { elapsedTime } from "utils/date";
import { fetchStudentInOutHistory } from "framework/students/profile";

function InOutTimeline({ admissionNo }) {
  const [inOutHistory, setInOutHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState(null);

  async function fetchInOutTimeline() {
    if (inOutHistory.length === 0) {
      try {
        setIsLoading(true);
        const inOutHistoryEntries = await fetchStudentInOutHistory(admissionNo);
        console.log(inOutHistoryEntries);
        setInOutHistory(inOutHistoryEntries);
      } catch (err) {
        console.error(err);
        setErr("Failed to get in out history, try refreshing.");
      } finally {
        setIsLoading(false);
      }
    }
  }
  useEffect(() => {
    fetchInOutTimeline();
    const intervalId = setInterval(() => {
      setInOutHistory((prev) => {
        if (prev.length !== 0) return [...prev];
        return prev;
      });
    }, 1000 * 60);
    return () => clearInterval(intervalId);
  }, []);
  return (
    <Card sx={{ height: "100%", position: "relative" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          In Out Timeline
        </MDTypography>
        {/* <MDBox mt={0} mb={2}>
          <MDTypography variant="button" color="text" fontWeight="regular">
            <MDTypography display="inline" variant="body2" verticalAlign="middle">
              <Icon color="success">arrow_upward</Icon>
            </MDTypography>
            &nbsp;
            <MDTypography variant="button" color="text" fontWeight="medium">
              {`xx%`}
            </MDTypography>{" "}
            In
          </MDTypography>
          <MDTypography variant="button" color="text" fontWeight="regular">
            <MDTypography display="inline" variant="body2" verticalAlign="middle">
              <Icon color="error">arrow_downward</Icon>
            </MDTypography>
            &nbsp;
            <MDTypography variant="button" color="text" fontWeight="medium">
              {`xx%`}
            </MDTypography>{" "}
            Out
          </MDTypography>
        </MDBox> */}
      </MDBox>
      {!isLoading && (
        <MDBox py={2} px={4}>
          {(err || inOutHistory?.length === 0) && (
            <MDTypography variant="body" align="center" px={3} sx={{ fontSize: "0.9rem" }}>
              {err ?? "No in, out history."}
            </MDTypography>
          )}
          {!err &&
            inOutHistory?.length !== 0 &&
            inOutHistory.map((inOutEntry, index) => (
              <TimelineItem
                key={index}
                color={inOutEntry.isIn ? "success" : "error"}
                icon={inOutEntry.isIn ? "person_add_alt_rounded" : "person_remove_rounded"}
                title={inOutEntry.isIn ? "Entered" : "Left"}
                dateTime={elapsedTime(inOutEntry.time.toDate())}
              />
            ))}
        </MDBox>
      )}
      <Backdrop open={isLoading} sx={{ position: "absolute", borderRadius: "0.75rem" }}>
        <CircularProgress />
      </Backdrop>
    </Card>
  );
}

export default InOutTimeline;
